export default "__VITE_ASSET__oZQcbrGr__"